import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import pt from './locales/pt.json';
import en from './locales/en/translation.json';
import es from './locales/es/translation.json';
import fr from './locales/fr/translation.json';
import de from './locales/de/translation.json';

const COOKIE_NAME = 'uclean_locale';

// Custom detector: check cookie, URL param, then browser
const customDetector = {
  name: 'ucleanDetector',
  lookup() {
    // 1. URL param ?lang=xx
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang');
    if (langParam && ['pt', 'en', 'es', 'fr', 'de'].includes(langParam)) {
      return langParam === 'pt' ? 'pt-BR' : langParam;
    }
    // 2. Cookie
    const cookie = document.cookie.split(';').find(c => c.trim().startsWith(COOKIE_NAME + '='));
    if (cookie) {
      const val = cookie.split('=')[1]?.trim();
      if (val) return val;
    }
    // 3. Let i18next LanguageDetector handle browser/navigator
    return undefined;
  },
  cacheUserLanguage(lng) {
    // Save to cookie (1 year)
    const expires = new Date(Date.now() + 365 * 86400000).toUTCString();
    document.cookie = `${COOKIE_NAME}=${lng};expires=${expires};path=/;SameSite=Lax`;
  },
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(customDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'pt-BR': { translation: pt },
      pt: { translation: pt },
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
      de: { translation: de },
    },
    fallbackLng: 'pt-BR',
    supportedLngs: ['pt-BR', 'pt', 'en', 'es', 'fr', 'de'],
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['ucleanDetector', 'navigator', 'htmlTag'],
      caches: [],
    },
  });

// Update <html lang="..."> on language change
i18n.on('languageChanged', (lng) => {
  const htmlLang = lng === 'pt-BR' ? 'pt-BR' : lng.split('-')[0];
  document.documentElement.setAttribute('lang', htmlLang);
  // Save to cookie
  const expires = new Date(Date.now() + 365 * 86400000).toUTCString();
  document.cookie = `${COOKIE_NAME}=${lng};expires=${expires};path=/;SameSite=Lax`;
});

if (i18n.language) {
  document.documentElement.setAttribute('lang', i18n.language.startsWith('pt') ? 'pt-BR' : i18n.language.split('-')[0]);
}

export default i18n;
